import { Injectable } from 'angular-ts-decorators';

import { ConnectableObservable, Observable, of, from } from 'rxjs';
import {
  filter,
  map,
  startWith,
  distinctUntilChanged,
  publishReplay,
  combineLatest,
} from 'rxjs/operators';
import { LocationStreams } from './location-streams';

/**
 * Service provides streams related to the current path
 */
@Injectable('pathStreams')
export class PathStreams {
  public current$: ConnectableObservable<any>;
  constructor(
    $location: ng.ILocationService,
    locationStreams: LocationStreams,
  ) {
    'ngInject';

    /**
     * Hot observable that emits the current path on subscribe & updates.
     */
    this.current$ = <ConnectableObservable<any>>locationStreams.changeSuccess$
      .pipe(filter((url) => url.match(/#([^?]*)/)))
      .pipe(
        map((url) => {
          // all that is between # & ? in the url
          return url.match(/#([^?]*)/)[1];
        }),
      )
      .pipe(startWith($location.path()))
      .pipe(distinctUntilChanged())
      .pipe(publishReplay(1));

    // Subscribes to the underlying stream
    this.current$.connect();
  }

  /**
   * @param {string|Observable} path
   * the path to compare to - as a string or as an Observable
   * Hot observable that emits the current path on subscribe & updates.
   * @returns {Observable}
   * emits true when the paths are the same, false otherwise
   */
  isSameAs(path: string | Observable<any>): Observable<any> {
    let path$;

    if (angular.isString(path)) {
      path$ = of(path);
    } else {
      path$ = from(path);
    }

    return this.current$
      .pipe(combineLatest(path$, (x, y) => x === y))
      .pipe(distinctUntilChanged());
  }
}
